<template>
  <div class="header-container">
    <!-- 主头部栏 -->
    <div class="header" :class="{ 'header-hidden': isHeaderHidden && !isMobile }" ref="mainHeaderRef">
      <!-- 左侧板块：Logo和公司名称 -->
      <div class="header-left">
        <div class="logo-container">
          <!-- <img src="@/assets/image/logo.png" alt="公司Logo" class="logo" /> -->
          <span class="logo-text">SAILOR</span>
        </div>

        <!-- 汉堡菜单按钮 -->
        <button class="hamburger-menu" @click="toggleMobileMenu">
          <div class="hamburger-line"></div>
          <div class="hamburger-line"></div>
          <div class="hamburger-line"></div>
        </button>
      </div>

      <!-- 中间板块：导航菜单 -->
      <nav class="header-middle" :class="{ 'mobile-menu-open': isMobileMenuOpen }">
        <ul class="nav-menu" :class="{ 'mobile-menu-open': isMobileMenuOpen }">
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToHome">首页</a></li>
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToSupport">服务产品</a></li>
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToPaltform">系统简介</a></li>
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToServe">服务优势</a></li>
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToSource">项目资源</a></li>
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToCaseContent">优秀案例</a></li>
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToConnectUs">联系我们</a></li>
        </ul>
      </nav>

      <!-- 右侧板块：登录、下载 -->
      <div class="header-right">
        <div class="header-download" @click.prevent="handleWebLogin">
          <img src="@/assets/image/webPage.svg" alt="网页登录" class="icon">
          <div class="header-text">
            <span style="color: #fff; font-size: 14px;">X-Sailor</span>
            <span style="color: #fff; font-size: 14px;">网页版登录</span>
          </div>
        </div>
        <div class="header-download" @click.prevent="handleWinDownload">
          <img src="@/assets/image/win_download.svg" alt="Win客户端下载" class="icon">
          <div class="header-text">
            <span style="color: #fff; font-size: 14px;">X-Sailor</span>
            <span style="color: #fff; font-size: 14px;">Win客户端下载</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 小头部栏 - 仅在PC端显示 -->
    <div class="mini-header" v-show="isHeaderHidden && !isMobile"
      :class="{ 'mini-header-visible': isHeaderHidden && !isMobile }">
      <!-- 中间板块：导航菜单 -->
      <nav class="header-middle">
        <ul class="nav-menu">
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToHome">首页</a></li>
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToSupport">服务产品</a></li>
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToPaltform">系统简介</a></li>
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToServe">服务优势</a></li>
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToSource">项目资源</a></li>
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToCaseContent">优秀案例</a></li>
          <li class="nav-item"><a href="#" class="nav-link" @click.prevent="goToConnectUs">联系我们</a></li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';

const isHeaderHidden = ref(false);
const isMobileMenuOpen = ref(false);
const isMobile = computed(() => window.innerWidth <= 768);

// 切换移动端菜单显示状态
const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

// 关闭移动端菜单
const closeMobileMenu = () => {
  isMobileMenuOpen.value = false;
};

const handleWebLogin = () => {
  window.open('https://x.sailortrade.top/#/login', '_blank');
  closeMobileMenu(); // 关闭移动端菜单
};

const handleWinDownload = () => {
  window.open('https://www.sailortrade.top/exe/X-Sailor跨境综服平台安装程序.exe', '_blank');
  closeMobileMenu(); // 关闭移动端菜单
};

const goToHome = () => {
  scrollToElement('.main-content');
  closeMobileMenu(); // 关闭移动端菜单
};

const goToSupport = () => {
  scrollToElement('.scrolling-images-section');
  closeMobileMenu(); // 关闭移动端菜单
};

// Vue 3 组合式 API 实现滚动到元素的方法
const scrollToElement = (selector) => {
  // 使用 document.querySelector 查找元素
  const element = document.querySelector(selector);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth'
    });
    closeMobileMenu(); // 关闭移动端菜单
  } else {
    console.warn(`Element with selector "${selector}" not found`);
  }
};

const goToPaltform = () => {
  // 滚动到服务流程板块，需要根据实际页面中的元素类名来设置
  scrollToElement('.paltform-content'); // 假设服务流程板块的类名是 server-main
  closeMobileMenu(); // 关闭移动端菜单
};
const goToServe = () => {
  scrollToElement('.advantage-content'); // 假设服务流程板块的类名是 server-main
  closeMobileMenu(); // 关闭移动端菜单
}
const goToSource = () => {
  // 滚动到资源板块
  scrollToElement('.experience-content'); // 需要根据实际页面元素的类名来设置
  closeMobileMenu(); // 关闭移动端菜单
};

const goToCaseContent = () => {
  scrollToElement('.case-content');
  closeMobileMenu(); // 关闭移动端菜单
};


const goToConnectUs = () => {
  scrollToElement('.footer-section');
  closeMobileMenu(); // 关闭移动端菜单
};

// 监听滚动事件
const handleScroll = () => {
  // 移动端始终不隐藏头部栏
  if (isMobile.value) {
    isHeaderHidden.value = false;
  } else {
    // PC端保留小菜单功能
    if (window.scrollY > 80) { // 80px是主头部栏的高度
      isHeaderHidden.value = true;
    } else {
      isHeaderHidden.value = false;
    }
  }

  // 滚动时关闭移动端菜单
  if (isMobileMenuOpen.value) {
    closeMobileMenu();
  }
};

// 监听窗口大小变化
const handleResize = () => {
  // 如果窗口变大，关闭移动端菜单
  if (window.innerWidth > 768 && isMobileMenuOpen.value) {
    closeMobileMenu();
  }

  // 根据窗口大小调整头部栏隐藏状态
  if (window.innerWidth <= 768) {
    isHeaderHidden.value = false; // 移动端始终显示头部栏
  }
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
  window.removeEventListener('resize', handleResize);
});
</script>

<style scoped>
.header-container {
  position: relative;
  width: 100%;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: none;
  height: 80px;
  padding: 0 40px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  z-index: 999;
  transition: all 0.5s ease;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.header:hover {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.header.header-hidden {
  transform: translateY(-100%);
  opacity: 0;
  visibility: hidden;
  /* 完全隐藏，不占用空间 */
  pointer-events: none;
  /* 禁用鼠标事件 */
}

.header-left {
  display: flex;
}

.logo-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.logo {
  width: 356px;
  height: 80px;
}

.logo-text{
  /* position: absolute; */
  /* bottom: 0px; */
  /* left:50px; */
  color: #0957a7;
  letter-spacing: 2px;
  font-weight: 600;
  font-size: 36px;
}

.mini-logo {
  width: 80px;
  max-height: 40px;
}

.company-name {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.header-middle {
  display: flex;
  align-items: center;
  flex: 1;
  /* 占据剩余空间 */
  justify-content: center;
  /* 居中对齐导航菜单 */
}

.header-right {
  display: flex;
  flex-direction: row;
  gap: 15px;
  flex: 0 0 auto;
  /* 固定宽度 */
}

.header-right-placeholder {
  width: 200px;
  /* 与主头部栏的右侧区域宽度保持一致 */
  flex: 0 0 auto;
}

.header-download {
  display: flex;
  flex-direction: row;
  background-color: #2a82e4;
  align-items: center;
  border-radius: 10px;
  padding: 8px 12px;
  cursor: pointer;
}

.mini-download {
  padding: 6px 8px;
}

.header-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;
}

.icon {
  margin: 0 5px;
  width: 20px;
  height: 20px;
}

.mini-icon {
  width: 16px;
  height: 16px;
}

.nav-menu {
  display: flex;
  list-style: none;
  justify-content: center;
  /* 确保菜单项居中 */
}

.nav-item {
  margin: 0 15px;
  /* 调整间距 */
}

.nav-link {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  transition: color 0.3s ease;
  white-space: nowrap;
  /* 防止文字换行 */
}

.nav-link:hover {
  color: #00a0bc;
  transform: translateY(-2px);
}

/* 小头部栏样式 */
.mini-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 0 20px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  z-index: 998;
  background-color: #445a9a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  transform: translateY(-100%);
}

.mini-header.mini-header-visible {
  transform: translateY(0);
}

.mini-header .nav-menu {
  gap: 100px;
  /* 菜单项之间的间距 */
}

.mini-header .nav-link {
  font-size: 18px;
  color: #fff;
}

.mini-header .header-left {
  flex: 0 0 auto;
}

.mini-header .header-middle {
  flex: 1;
  justify-content: center;
  overflow-x: auto;
  /* 如果菜单项太多，允许水平滚动 */
}

.mini-header .nav-item {
  margin: 0 5px;
}

.mini-header .header-right-placeholder {
  width: 50px;
  /* 小头部栏中使用较小的占位区域 */
}

/* 移动端适配样式 */
@media (max-width: 768px) {
  .header {
    height: 60px;
    padding: 0 15px;
    flex-direction: column;
    align-items: flex-start;
  }

  .header-left {
    width: 100%;
    justify-content: space-between;
    padding: 10px 0;
  }

  .logo {
    width: 200px;
    height: auto;
    max-height: 40px;
  }

  .header-middle {
    width: 100%;
    order: 2;
    /* 将导航菜单移到下方 */
    justify-content: center;
    padding: 10px 0;
  }

  .header-right {
    width: 100%;
    order: 3;
    /* 将右侧按钮移到最后 */
    justify-content: center;
    padding: 10px 0;
    gap: 10px;
  }

  .header-download {
    padding: 6px 10px;
    border-radius: 8px;
  }

  .icon {
    width: 18px;
    height: 18px;
    margin: 0 3px;
  }

  .header-text {
    margin: 0 3px;
  }

  .header-text span {
    font-size: 12px;
  }

  .nav-menu {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }

  .nav-item {
    margin: 3px 8px;
  }

  .nav-link {
    font-size: 14px;
  }

  /* 移动端导航菜单滚动优化 */
  .nav-menu {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    /* iOS平滑滚动 */
    padding-bottom: 5px;
  }

  .nav-menu::-webkit-scrollbar {
    height: 4px;
  }

  .nav-menu::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  .nav-menu::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  .nav-menu::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  .mini-header {
    display: none;
  }
}

@media (max-width: 480px) {
  .header {
    height: 60px;
    padding: 0 10px;
  }

  .logo {
    width: 150px;
    max-height: 40px;
  }

  .header-right {
    flex-direction: column;
    gap: 8px;
    align-items: center;
  }

  .header-download {
    width: 100%;
    max-width: 200px;
    justify-content: center;
  }

  .nav-item {
    margin: 2px 5px;
  }

  .nav-link {
    font-size: 13px;
  }

  .header-text span {
    font-size: 11px;
  }
}

/* 移动端小头部栏适配 */
@media (max-width: 768px) {
  .mini-header {
    height: 50px;
    padding: 0 10px;
  }

  .mini-header .nav-menu {
    gap: 15px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .mini-header .nav-link {
    font-size: 14px;
  }

  .mini-header .nav-item {
    margin: 0 5px;
  }
}

@media (max-width: 480px) {
  .mini-header .nav-menu {
    gap: 10px;
  }

  .mini-header .nav-link {
    font-size: 12px;
  }
}

/* 添加汉堡菜单样式 */
.hamburger-menu {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  box-sizing: border-box;
  margin-left: auto;
}

.hamburger-line {
  width: 100%;
  height: 2px;
  background: #333;
  border-radius: 10px;
  transition: all 0.3s;
}

@media (max-width: 768px) {
  .hamburger-menu {
    display: flex;
  }

  .nav-menu {
    display: none;
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    background: white;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }

  .nav-menu.mobile-menu-open {
    display: flex;
  }

  .nav-item {
    margin: 10px 0;
  }

  .header-right {
    display: none;
  }

  .header-right.mobile-menu-open {
    display: flex;
    position: absolute;
    top: 180px;
    /* 根据导航菜单高度调整 */
    left: 0;
    width: 100%;
    background: white;
    padding: 20px 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    flex-direction: column;
  }

  .logo {
    width: 180px;
    max-height: 40px;
  }
}
</style>